import Path from './Path';
import * as treeUtils from './treeUtils';

// TODO: move into TreeModel instance, because this is horrible
const CSS_CLASSES: Record<string, string> = {
  treeClass: '',
  treeNodeClass: '',
  treeNodeLabelClass: '',
  collapsedClass: '',
  emptyDropdownClass: '',
};

function initCssClasses(options: AnyFixMe) {
  CSS_CLASSES.treeClass = options.treeClass;
  CSS_CLASSES.treeNodeClass = options.treeNodeClass;
  CSS_CLASSES.treeNodeLabelClass = options.treeNodeLabelClass;
  CSS_CLASSES.collapsedClass = options.collapsedClass;
  CSS_CLASSES.emptyDropdownClass = options.emptyDropdownClass;
  CSS_CLASSES.previewClass = options.previewClass;
}

function isTree(dom: HTMLElement) {
  return treeUtils.hasClass(dom, CSS_CLASSES.treeClass);
}

function isTreeNode(dom: HTMLElement) {
  return treeUtils.hasClass(dom, CSS_CLASSES.treeNodeClass);
}

function isCollapsed(dom: HTMLElement) {
  return treeUtils.hasClass(dom, CSS_CLASSES.collapsedClass);
}

function isEmptyDropdown(dom: HTMLElement) {
  return treeUtils.hasClass(dom, CSS_CLASSES.emptyDropdownClass);
}

function canBeChild(dom: HTMLElement) {
  return dom?.dataset?.canBeChild === 'true';
}

function canBeParent(dom: HTMLElement) {
  return dom?.dataset?.canBeParent === 'true';
}

/**
 * TreeModel
 *
 * @constructor
 * @param {HTMLDomElement} dom
 * @param options
 */
class TreeModel {
  private children: AnyFixMe[];

  constructor(
    public dom: HTMLElement,
    public options: AnyFixMe,
  ) {
    initCssClasses(options);

    this.children = [];
    this.refresh();
  }

  getChildHeight() {
    const child = this.children[0];
    const label = child && child.getLabel();
    const rect = label && label.getBoundingClientRect();

    return rect ? Math.round(rect.height * 1.15) : NaN;
  }

  refresh() {
    if (this.dom) {
      this.children = getChildren(this.dom);
    }
  }

  findByDom(li: AnyFixMe) {
    if (this.dom === li) {
      return attachPath(new ChildInfo(this.dom), new Path());
    }

    let path = findPathByDom(this, li, []);

    if (Array.isArray(path)) {
      path = new Path(path);

      const child = this.findByPath(path);
      return attachPath(child, path);
    }

    return null;
  }

  findByPath(path: Path) {
    const child = path.findIn(this, 'children') || null;
    return attachPath(child, path);
  }

  findParentTree(path: Path) {
    const parent = this.findByPath(path.parent());

    if (parent && !isTree(parent.dom)) {
      return (
        parent.dom.getElementsByClassName(CSS_CLASSES.treeClass)[0] || null
      );
    }

    return parent?.dom;
  }

  insert(el: AnyFixMe, path: Path) {
    const parent = this.findParentTree(path);
    const index = getIndex(parent.children, el);
    const toIndex = path.atRight();
    const offset = index >= 0 && index < toIndex ? 1 : 0;
    const child = parent?.children[toIndex + offset];

    if (index === toIndex) {
      return;
    }

    if (child) {
      parent.insertBefore(el, child);
    } else {
      parent.appendChild(el);
    }

    this.refresh();
  }
}

function findPathByDom(parent: AnyFixMe, dom: AnyFixMe, path: AnyFixMe) {
  return parent.children.reduce(function (
    result: AnyFixMe,
    child: AnyFixMe,
    index: AnyFixMe,
  ) {
    if (result) {
      return result;
    }

    if (child.dom === dom) {
      return path.concat(index);
    }

    return findPathByDom(child, dom, path.concat(index));
  }, null);
}

function attachPath(childInfo: ChildInfo, path: Path) {
  if (childInfo) {
    childInfo.path = path;
  }

  return childInfo;
}

class ChildInfo {
  public dom: HTMLElement;
  public path: Path;
  public children: AnyFixMe;
  public childrenLength: number;

  constructor(li: HTMLElement) {
    const tree = li.getElementsByClassName(CSS_CLASSES.treeClass)[0];

    this.dom = li;
    this.path = undefined;
    this.children = getChildren(tree as HTMLElement);
    this.childrenLength = parseInt(
      this.dom.getAttribute('data-numofchildren') || '0',
      10,
    );
  }

  getLabel() {
    const label = this.dom.getElementsByClassName(
      CSS_CLASSES.treeNodeLabelClass,
    )[0];

    if (label && label.parentNode !== this.dom) {
      return null;
    }

    return label;
  }

  hasChildren() {
    return this.childrenLength > 0;
    //return this.children && this.children.length > 0;
  }

  canBeChild() {
    return !this.hasChildren() && canBeChild(this.dom);
  }

  canBeParent() {
    return canBeParent(this.dom);
  }

  isCollapsed() {
    return this.hasChildren() && isCollapsed(this.dom);
  }

  isEmptyDropdown() {
    return isEmptyDropdown(this.dom);
  }

  getFirstInsertPosition() {
    if (this.isCollapsed()) {
      return this.getLastInsertPosition();
    }

    return 0;
  }

  getLastInsertPosition(strict?: AnyFixMe) {
    if (strict) {
      return Math.max(0, (this.childrenLength || this.children.length) - 1);
    }

    return this.childrenLength || this.children.length;
  }
}

function getIndex(collection: AnyFixMe, item: AnyFixMe) {
  for (let i = 0; i < collection.length; i++) {
    if (collection[i] === item) {
      return i;
    }
  }

  return -1;
}

function getChildInfo(li: HTMLElement) {
  return new ChildInfo(li);
}

function getChildren(ul: HTMLElement) {
  if (ul?.children && ul.children.length > 0) {
    const children = Array.prototype.slice.call(ul.children);
    return children.filter(isTreeNode).map(getChildInfo);
  }

  return [];
}

export default TreeModel;
